<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-body tab2-card">
          <form [formGroup]="form" class="needs-validation" novalidate>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label>Operator de retea</label>
                <input class="form-control" type="text" formControlName="operatorName">
              </div>
              <div class="col-xl-4 col-md-4">
                <label>CLC<span>*</span></label>
                <input class="form-control" type="text" formControlName="code">
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <h4> Adresa locului de consum </h4>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-4 col-sm-4 mb-0">
                <label>Judet<span>*</span></label>
                <select class="form-control digits" formControlName="county" (change)="onChangeCounty()">
                  <option *ngFor="let county of counties" [value]="county.id">
                    {{ county.name }}
                  </option>
                </select>
              </div>
              <div class="col-xl-4 col-sm-4 mb-0">
                <label>Localitate<span>*</span></label>
                <select class="form-control digits" formControlName="city">
                  <option *ngFor="let city of cities" [value]="city.id">
                    {{ city.name }} </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label>Strada<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetName" required />
                <div *ngIf="form.controls['streetName'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                  class="text text-danger">
                  Numele strazii este obligatoriu
                </div>
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Numar<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetNumber" required />
                <div *ngIf="form.controls['streetNumber'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                  class="text text-danger">
                  Numarul strazii este obligatoriu
                </div>
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Bloc</label>
                <input class="form-control" type="text" formControlName="block" />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label>Etaj</label>
                <input class="form-control" type="text" formControlName="floor" />
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Apartament</label>
                <input class="form-control" type="text" formControlName="apartment" />
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Cod postal<span>*</span></label>
                <input class="form-control" type="text" formControlName="postalCode" required />
                <div *ngIf="form.controls['postalCode'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                  class="text text-danger">
                  Codul postal este obligatoriu
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label class="d-block">
                  <input class="checkbox_animated" type="checkbox" formControlName="connectionNotice">
                  Aviz tehnic de racordare<span>*</span>
                </label>
              </div>
              <ng-container *ngIf="!!form?.controls?.connectionNotice?.value">
                <div class="col-xl-4 col-md-4">
                  <label>Numar<span>*</span></label>
                  <input class="form-control" type="text" formControlName="connectionNoticeNumber">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Data<span>*</span></label>
                  <input class="form-control" type="date" formControlName="connectionNoticeDate"
                    onkeydown="return false">
                </div>
              </ng-container>
            </div>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label class="d-block">
                  <input class="checkbox_animated" type="checkbox" formControlName="accessAgreement">
                  Acord de acces<span>*</span>
                </label>
              </div>
              <ng-container *ngIf="!!form?.controls?.accessAgreement?.value">
                <div class="col-xl-4 col-md-4">
                  <label>Numar<span>*</span></label>
                  <input class="form-control" type="text" formControlName="accessAgreementNumber">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Data<span>*</span></label>
                  <input class="form-control" type="date" formControlName="accessAgreementDate"
                    onkeydown="return false">
                </div>
              </ng-container>
            </div>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label>Exista un sistem de masurare inteligent<span>*</span></label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="smartMeter" formControlName="smartMeter" value='true'
                    [checked]="this.form.value.smartMeter === true">
                  DA
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="smartMeter" formControlName="smartMeter"
                    value='false' [checked]="this.form.value.smartMeter === false">
                  NU
                </label>
              </div>
              <ng-container>
                <div class="col-xl-4 col-md-4">
                  <label>Tip contor<span>*</span></label>
                  <select class="form-control digits" formControlName="counterType">
                    <option value="GAS">GAZ</option>
                  </select>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Serie contor<span>*</span></label>
                  <input class="form-control" type="text" formControlName="counterSeries">
                </div>
              </ng-container>
            </div>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label>Status loc de consum<span>*</span></label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="technicalDataStatus"
                    formControlName="technicalDataStatus" value='CONECTAT' [checked]="isConsumptionPlaceConnected">
                  Conectat
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="technicalDataStatus"
                    formControlName="technicalDataStatus" value='DECONECTAT' [checked]="isConsumptionPlaceDisconnected">
                  Deconectat
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="technicalDataStatus"
                    formControlName="technicalDataStatus" value='INACTIV' [checked]="isConsumptionPlaceInactive">
                  Inactiv
                </label>
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Tip retea<span>*</span></label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="networkType" value='D'
                    [checked]="isNetworkTypeDistribution" formControlName="networkType"
                    (click)="setDefaultConsumptionCategory('D')">
                  Distributie
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="networkType" value='T'
                    (click)="setDefaultConsumptionCategory('T')" [checked]="isNetworkTypeTransport"
                    formControlName="networkType">
                  Transport
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="networkType" value='CA' [checked]="isNetworkTypeCA"
                    (click)="setDefaultConsumptionCategory('CA')" formControlName="networkType">
                  Conducte de alimentare din amonte
                </label>
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Regim de functionare<span>*</span></label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="operatingMode" value='PERMANENT'
                    [checked]=isOperatingModePermanent formControlName="operatingMode">
                  Permanent
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" value="SEZONIER" name="operatingMode" value='SEZONIER'
                    [checked]=isOperatingModeSeasonal formControlName="operatingMode">
                  Sezonier
                </label>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label>Categoria de consum<span>*</span></label>
                <select class="form-control digits" formControlName="consumptionCategory">
                  <ng-container *ngIf="this.isNetworkTypeDistribution">
                    <option value="C_1">C_1</option>
                    <option value="C_2">C_2</option>
                    <option value="C_3">C_3</option>
                    <option value="C_4">C_4</option>
                    <option value="C_5">C_5</option>
                    <option value="C_6">C_6</option>
                    <option value="C_7">C_7</option>
                  </ng-container>
                  <ng-container *ngIf="this.isNetworkTypeTransport || this.isNetworkTypeCA">
                    <option value="C_8">Client cu un consum anual mai mic sau egal cu 28.000 MWh</option>
                    <option value="C_9">Client cu un consum anual de peste 28.000 MWh</option>
                  </ng-container>
                </select>
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Debit aprobat (mc/h)<span>*</span></label>
                <input class="form-control" type="number" formControlName="debit">
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Capacitate rezervata (MWh/h)<span>*</span></label>
                <input class="form-control" type="number" formControlName="reservedCapacity">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label>Presiune cf. ATR (Pa)<span>*</span></label>
                <input class="form-control" type="number" formControlName="pressure">
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Presiune minima (Pa)<span>*</span></label>
                <input class="form-control" type="number" formControlName="minimumPressure">
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Presiune maxima (Pa)<span>*</span></label>
                <input class="form-control" type="number" formControlName="maximumPressure">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label>Presiune minima tehnologica (Pa)<span>*</span></label>
                <input class="form-control" type="number" formControlName="minimumTechnicalPressure">
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Perioada citire index(luni)<span>*</span></label>
                <input class="form-control" type="number" formControlName="counterIndexInterval">
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Descriere modalitate de completare index de la OR<span>*</span></label>
                <textarea class="form-control"
                  placeholder="Trebuie sa completati valoare index multi-cadran: ex. 1.8.1:546|1.8.2:532|"
                  formControlName="counterIndexDesc"></textarea>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-4 col-md-4">
                <label>Valoarea ultimului index citit</label>
                <input class="form-control" formControlName="counterIndexValue">
              </div>
              <div class="col-xl-4 col-md-4">
                <label>Data ultimului index citit</label>
                <input class="form-control" type="date" formControlName="counterIndexReadDate" onkeydown="return false">
              </div>
            </div>
            <br>
            <div class="form-group row mb-0 pull-right">
              <div class="col-xl-auto col-md-auto col-sm-auto">
                <button [routerLink]="'..'" type="button" class="btn btn-light button-margin">Renunta</button>
                <button *ngIf="editable" type="button" class="btn btn-primary mr-1 button-margin" (click)="onSubmit()">
                  Salveaza
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>